"use client";
import { PropsWithChildren } from "react";
import { Platform } from "react-native";
import PortalMobile from "./PortalMobile";
import PortalWeb from "./PortalWeb";

export default function Portal(props: PropsWithChildren) {
  if (Platform.OS === "web") {
    return <PortalWeb {...props} />;
  }

  return <PortalMobile {...props} />;
}
